/** @internal */
export const EffectTypeId = /*#__PURE__*/Symbol.for("@effect/io/Effect");
/** @internal */
export const effectVariance = {
  _R: _ => _,
  _E: _ => _,
  _A: _ => _
};
//# sourceMappingURL=Effect.mjs.map